module.exports = __webpack_public_path__ + "img/EXTERIOR-FRONX-BOOSTERGREEN-1.f513638c.jpg";